import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Table from './Tab'

export default class extends Component {
  render() {
    return (
      <HeaderView title="套餐优化">
        <div style={{ marginTop: 20 }}>
          <Table />
        </div>
      </HeaderView>
    )
  }
}
